import { Category } from '@interfaces/category';
import { fetcher } from '@utils/fetcher';

export const findCategories = async (): Promise<Category[]> =>
  fetcher('/api/category');
